import React, { useEffect } from 'react';
import Card from '../Card';
import './PlayerStatsOverlay.scss';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsOverlayShowing, togglePlayerOverlayShowing, selectOverlayPlayer } from '../../../redux/overlaySlice';
import { monsterNameFromId, monsterClassFromId } from '../../../monsters';
import { useCallback } from 'react';
import cardList from '../../../cardList';
import { getMaxPlayerHealth } from '../../../playerUtils';
import { Trans } from '@lingui/macro';

export default function PlayerStatsOverlay() {
    const dispatch = useDispatch();
    const isOverlayShowing = useSelector(selectIsOverlayShowing);
    const player = useSelector(selectOverlayPlayer);

    const clickOverlay = (ev) => {
        if (ev.target.id === "show-cards-overlay" || ev.target.classList.contains("fa-times")) {
            dispatch(togglePlayerOverlayShowing());
        }
    };

    const checkExitOverlay = useCallback((ev) => {
        ev.stopPropagation();
        // Check if hitting ESC
        if (ev.keyCode === 27) {
            dispatch(togglePlayerOverlayShowing());
        }
    }, [dispatch]);

    useEffect(() => {
        if (isOverlayShowing === false) {
            return;
        }

        document.addEventListener("keydown", checkExitOverlay);
        return () => document.removeEventListener("keydown", checkExitOverlay)
    }, [isOverlayShowing, checkExitOverlay]);

    if (!isOverlayShowing || !player) {
        return null;
    }

    let playerCards = [],
        cardsWithIndex = [];
    for (let cardIdx in player.cards) {
        cardsWithIndex.push({
            idx: cardIdx,
            cardId: player.cards[cardIdx]
        });
    }

    let sortedCardList = cardsWithIndex.sort((cardIdA, cardIdB) => {
        const cardA = cardList[cardIdA.cardId];
        const cardB = cardList[cardIdB.cardId];
        if (cardA.use_mode !== cardB.use_mode) {
            return cardA.use_mode === "KEEP" ? -1 : 1;
        }
        return 0;
    });

    for (let j = 0; j < sortedCardList.length; j++) {
        playerCards.push(<Card type={sortedCardList[j].cardId} key={sortedCardList[j].idx} />);
    }

    if (player.cards.length === 0) {
        playerCards.push(<div key="fake-card-player-status">
            <div className="fake-card">
                <div className="fake-card-smaller-container">
                    <Trans>The player has no cards</Trans>
                </div>
                <div className="card-appendix-hovering"></div>
            </div>
        </div>);
    }

    return <div id="show-cards-overlay" className="esc-overlay noselect overlay-background dark-background-overlay" onClick={clickOverlay}>
        <div id="show-cards-overlay-content-wrap">
            <i className="fas fa-times"></i>
            <div id="show-cards-header">
                <div id="show-cards-header-monster-image" className={`game-sprite ${monsterClassFromId(player.monster_id)}`}></div>
                <div id="show-cards-header-content">
                    <p className="show-cards-overlay-title"><Trans>Player Status Overview</Trans></p>
                    <p><span className="show-cards-overlay-small-title"><Trans>Player name:</Trans> </span><span className="show-cards-overlay-small-text">{player.name}</span></p>
                    <p><span className="show-cards-overlay-small-title"><Trans>Monster:</Trans> </span><span className="show-cards-overlay-small-text">{monsterNameFromId(player.monster_id)}</span></p>

                    <div id="show-cards-player-stats">
                        <p className="show-cards-overlay-medium-title"><Trans>Player stats</Trans></p>
                        <div id="show-cards-player-stats-content">
                            <div className="show-cards-player-stat-number">{player.health} / {getMaxPlayerHealth(player)}</div>
                            <div className="game-sprite show-cards-player-stat-icon heart-stat-icon"></div>
                            <div className="show-cards-player-stat-number">{player.stars} / 20</div>
                            <div className="game-sprite show-cards-player-stat-icon star-stat-icon"></div>
                            <div className="show-cards-player-stat-number">{player.energy}</div>
                            <div className="game-sprite show-cards-player-stat-icon energy-stat-icon"></div>
                            <div className="show-cards-player-stat-number">{player.cards.length}</div>
                            <div className="game-sprite show-cards-player-stat-icon cards-stat-icon"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="show-cards-cards-container">
                <p className="show-cards-overlay-medium-title"><Trans>Cards owned</Trans></p>
                <div className="card-aligner">
                    {playerCards}
                </div>
            </div>
        </div>
    </div>;
}
